export enum PREFERENCE_COOKIE {
  ACCEPTED = 'accepted'
}
